module.exports = __webpack_public_path__ + "img/table.0df61ad1.svg";